import { useMemo } from "react";
import { Navigate, useLocation } from "react-router-dom";

import { FlexiblePage } from "@/components/FlexiblePage";
import { buildFlexibleSlugs } from "@/lib/routing";

export default function ProductDetail() {
  const location = useLocation();

  const slugs = useMemo(() => {
    const candidates = buildFlexibleSlugs(location.pathname);
    return candidates.length > 0 ? candidates : [];
  }, [location.pathname]);

  if (slugs.length === 0) {
    return <Navigate to="/products" replace />;
  }

  const prerenderId = `__PR_DETAIL__${slugs.join("__").toUpperCase()}`;

  return (
    <FlexiblePage
      key={location.pathname}
      slugs={slugs}
      prerenderId={prerenderId}
      fallbackTitle="Products"
      loadingLabel="Loading product…"
    />
  );
}
